import React, { useEffect, useState } from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { HERO_SLIDES } from '../mock/mock';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;

const normalizeSlide = (b) => ({
  id: b.id,
  tag: b.tag || 'Featured',
  title: b.title,
  subtitle: b.subtitle || '',
  image: b.image_url?.startsWith('/api/') ? `${BACKEND}${b.image_url}` : b.image_url,
  cta: b.cta_label || 'Explore',
  href: b.cta_href || '/corporate-gifting',
});

const Hero = () => {
  const [slides, setSlides] = useState(HERO_SLIDES);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    axios.get(`${API}/banners`).then(r => {
      if (r.data && r.data.length > 0) setSlides(r.data.map(normalizeSlide));
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (slides.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % slides.length), 6000);
    return () => clearInterval(t);
  }, [slides.length]);

  const s = slides[idx] || slides[0];
  if (!s) return null;
  const href = s.href || '/corporate-gifting';

  return (
    <section className="relative bg-[#FAF6F1] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 pt-10 md:pt-16 pb-10">
        <div className="grid lg:grid-cols-12 gap-8 items-center">
          {/* Copy */}
          <div className="lg:col-span-6 relative z-10">
            <div className="inline-flex items-center gap-2 bg-[#F4D5C5] text-[#7A5C4C] px-4 py-1.5 rounded-full text-xs uppercase tracking-widest">
              <Sparkles className="w-3.5 h-3.5" /> {s.tag}
            </div>
            <h1 key={s.id} className="font-serif-display text-4xl sm:text-5xl lg:text-6xl xl:text-7xl text-[#2C2416] leading-[1.05] mt-5 fade-up">
              {s.title}
            </h1>
            <p className="text-base md:text-lg text-[#5B4A3A] mt-6 max-w-xl leading-relaxed">{s.subtitle}</p>
            <div className="flex flex-wrap gap-3 mt-8">
              <Link to={href} className="btn-primary px-6 py-3 rounded-full text-sm uppercase tracking-widest inline-flex items-center gap-2">
                {s.cta} <ArrowRight className="w-4 h-4" />
              </Link>
              <a href="#enquire" className="btn-outline px-6 py-3 rounded-full text-sm uppercase tracking-widest">
                Talk to a Stylist
              </a>
            </div>

            <div className="flex items-center gap-8 mt-10 pt-8 border-t border-[#E9DFD3]">
              <div><div className="font-serif-display text-2xl text-[#2C2416]">2k+</div><div className="text-xs uppercase tracking-widest text-[#7A5C4C]">Brand partners</div></div>
              <div><div className="font-serif-display text-2xl text-[#2C2416]">200+</div><div className="text-xs uppercase tracking-widest text-[#7A5C4C]">Hamper designs</div></div>
              <div className="hidden sm:block"><div className="font-serif-display text-2xl text-[#2C2416]">PAN</div><div className="text-xs uppercase tracking-widest text-[#7A5C4C]">India delivery</div></div>
            </div>
          </div>

          {/* Visual */}
          <div className="lg:col-span-6 relative">
            <div className="absolute -top-6 -right-6 w-56 h-56 rounded-full pastel-blush opacity-70 blur-2xl" aria-hidden />
            <div className="absolute -bottom-10 -left-10 w-64 h-64 rounded-full pastel-sage opacity-60 blur-2xl" aria-hidden />

            <div className="relative grid grid-cols-6 grid-rows-6 gap-3 h-[420px] md:h-[520px]">
              <div className="col-span-4 row-span-4 rounded-2xl overflow-hidden shadow-xl">
                <img key={s.image} src={s.image} alt="Hero gift" className="w-full h-full object-cover fade-up" />
              </div>
              <div className="col-span-2 row-span-3 rounded-2xl overflow-hidden pastel-peach flex flex-col items-center justify-center p-4 text-center">
                <div className="font-serif-display text-3xl text-[#2C2416] leading-none">98%</div>
                <div className="text-[11px] uppercase tracking-widest text-[#7A5C4C] mt-2">Client love</div>
              </div>
              <div className="col-span-2 row-span-3 rounded-2xl overflow-hidden">
                <img src="https://images.unsplash.com/photo-1668127494486-f27a1d2b88f9" alt="gift" className="w-full h-full object-cover" />
              </div>
              <div className="col-span-4 row-span-2 rounded-2xl overflow-hidden pastel-sage flex items-center px-6">
                <div>
                  <div className="font-serif-display text-xl text-[#2C2416]">Curated by stylists</div>
                  <div className="text-xs uppercase tracking-widest text-[#5B4A3A] mt-1">Semi-custom · Fully bespoke</div>
                </div>
              </div>
            </div>

            {/* Dots */}
            <div className="flex gap-2 mt-6 justify-center lg:justify-end">
              {slides.map((_, i) => (
                <button key={i} onClick={() => setIdx(i)} aria-label={`slide ${i + 1}`}
                  className={`h-1.5 rounded-full transition-all ${i === idx ? 'w-8 bg-[#2C2416]' : 'w-3 bg-[#D9C7B4] hover:bg-[#7A5C4C]'}`} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
